import { z } from 'zod'

export const expenseResponseSchema = z.object({
  id: z.string().guid(),
  description: z.string().nullable(),
  amount: z.number(),
  currency: z.string(),
  spentAmount: z.number().nullable(),
  conversionRate: z.number().nullable(),
  date: z.string(),
  accountId: z.string().guid().nullable(),
  categoryId: z.string().guid().nullable(),
  categoryIsSystem: z.boolean(),
  isSettled: z.boolean(),
  isRecurring: z.boolean(),
  groupId: z.string().guid().nullable(),
  groupName: z.string().nullable(),
  isOwner: z.boolean(),
  sharePercentage: z.number().nullable(),
  // amount * sharePercentage / 100 for shared expenses; equals amount otherwise
  myShareAmount: z.number(),
  myShareSpentAmount: z.number().nullable(),
})

export type ExpenseResponseDto = z.infer<typeof expenseResponseSchema>
